import { render } from "./RequestQuotation.vue?vue&type=template&id=639c2434&scoped=true"
import script from "./RequestQuotation.vue?vue&type=script&lang=js"
export * from "./RequestQuotation.vue?vue&type=script&lang=js"

import "./RequestQuotation.vue?vue&type=style&index=0&id=639c2434&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639c2434"]])

export default __exports__